export default "__VITE_ASSET__3551a7e4__"